import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import { ForecastingType } from "@type/inventory/forecasting";

export const ForecastingListTableColumn = (
  t: TFunction<"translation", undefined>,
) => {
  return [
    {
      id: 1,
      key: "group",
      name: t("INVENTORY_FORECASTING_LIST.TABLE.COLUMN.GROUP"),
      render: (_: string, row: ForecastingType) => {
        return <Text color="subtitle1" className="text-nowrap">{row.group.name}</Text>;
      },
    },
    {
      id: 2,
      key: "category",
      name: t("INVENTORY_FORECASTING_LIST.TABLE.COLUMN.CATEGORY"),
      render: (_: string, row: ForecastingType) => {
        return <Text color="subtitle1" className="text-nowrap">{row.category.name}</Text>;
      },
    },
    {
      id: 3,
      key: "type",
      name: t("INVENTORY_FORECASTING_LIST.TABLE.COLUMN.TYPE"),
      render: (type: string) => <Text weight="bold" color={type.toUpperCase() === "ASSET" ? "warning" : "primary"}>{type}</Text>,
    },
    {
      id: 4,
      key: "lastYearPurchase",
      className: "text-nowrap",
      name: t("INVENTORY_FORECASTING_LIST.TABLE.COLUMN.LAST_YEAR_PURCHASED"),
      render: (lastYearPurchase: number) => (
        <Text color="info">{lastYearPurchase && Number(lastYearPurchase) >= 0 ? lastYearPurchase : "..."}</Text>
      ),
    },
    {
      id: 5,
      key: "totalPrice",
      className: "text-nowrap",
      name: t("INVENTORY_FORECASTING_LIST.TABLE.COLUMN.TOTAL_PRICE"),
      render: (totalPrice: number) => (
        <Text color="subtitle2">{totalPrice || "..."}</Text>
      ),
    },
    {
      id: 6,
      key: "lastYearUses",
      className: "text-nowrap",
      name: t("INVENTORY_FORECASTING_LIST.TABLE.COLUMN.LAST_YEAR_USES"),
      render: (lastYearUses: number) => (
        <Text color="subtitle2">{lastYearUses && Number(lastYearUses) >= 0 ? lastYearUses : "..."}</Text>
      ),
    },
    {
      id: 7,
      key: "unitInStock",
      className: "text-nowrap",
      name: t("INVENTORY_FORECASTING_LIST.TABLE.COLUMN.UNIT_OF_STOCK"),
      render: (unitInStock: string) => (
        <Text color="subtitle1">{unitInStock && Number(unitInStock) >= 0 ? unitInStock : "..."}</Text>
      ),
    },
    {
      id: 8,
      key: "forecastAmount",
      className: "text-nowrap",
      name: t("INVENTORY_FORECASTING_LIST.TABLE.COLUMN.FORECASTED_AMOUNT"),
      render: (forecastAmount: number) => (
        <Text color="subtitle1">{forecastAmount && Number(forecastAmount) >= 0 ? forecastAmount : "..."}</Text>
      ),
    },
    {
      id: 8,
      key: "forecastBudget",
      className: "text-nowrap",
      name: t("INVENTORY_FORECASTING_LIST.TABLE.COLUMN.FORECASTED_BUDGET"),
      render: (forecastBudget: string) => (
        <Text color="subtitle1">{forecastBudget && Number(forecastBudget) >= 0 ? forecastBudget : "..."}</Text>
      ),
    },
  ];
};
